export default __webpack_public_path__ + "static/ROLVEDON-Distribution-Flashcard-33cfdd156062f653978afe3fcf709333.png";